exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".hextech-quintBody-3N6HS{fill:#182632}.hextech-quintBodyStroke-1VCAk{fill:url(#quintBodyStroke)}.hextech-quintBodyInner-32N8b{fill:url(#quintBodyInner)}\n", ""]);

// Exports
exports.locals = {
	"quintBody": "hextech-quintBody-3N6HS",
	"quintBodyStroke": "hextech-quintBodyStroke-1VCAk",
	"quintBodyInner": "hextech-quintBodyInner-32N8b"
};